import localStorageUtil from '@/common/utils/localStorageUtil';
import { Auth } from 'aws-amplify';
import API from '@aws-amplify/api';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { getProjectUserInUseDetail } from '@/service/projectService';
import { getUserById } from '@/service/userService';
import sessionStorageUtil from '@/common/utils/sessionStorageUtil';
import { getCorporationById } from './organizationService';
import { deleteCookieCdn } from './userService';
import { unSubscriptionEventDeleteUser } from '@/component/common/layout/header/handler/HeaderTopHandler';
import { matchPath } from 'react-router';

import { setRecoil } from 'recoil-nexus';
import { notificationListAtom, notificationUnReadListAtom } from '@/state/atom/notificationAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { listFormOfCorporationAtom, fieldListOfCorporationAtom } from '@/state/atom/formAtom';
import { multiPanelAtom, panelStartIndexAtom, panelSlideCurrentIndexAtom } from '@/state/atom/panelAtom';
import { projectListInCorporationAtom } from '@/state/atom/projectAtom';
import { userAtom } from '@/state/atom/userAtom';
import {
    helpdeskTicketListDefaultSelectedOptionAtom,
    helpdeskTicketListDrillDownDataAtom,
    helpdeskTicketListDefaultDrillDownDataAtom
} from '@/state/atom/ticketAtom';
import {
    projectInuseDefaultSelectedOptionAtom,
    helpdeskDefaultSelectedOptionAtom,
    projectInuseDrillDownDataAtom,
    helpdeskDrillDownDataAtom,
    projectInuseDefaultDrillDownDataAtom,
    helpdeskDefaultDrillDownDataAtom
} from '@/state/atom/ticketKnowledgeAtom';

const NOT_AUTHEN_ROUTER_LIST = [
    // Constant.LOGIN_ROUTER,
    Constant.CREATE_ORGANIZATION_ROUTER,
    Constant.CONFIRM_CREATE_ORGANIZATION_ROUTER,
    Constant.CREATE_ORGANIZATION_SUCCESS_ROUTER,
    Constant.CREATE_GUEST_CONTRACT_ROUTER,
    Constant.CONFIRM_CREATE_GUEST_CONTRACT_ROUTER,
    Constant.APPROVE_PAGE_ROUTER,
    Constant.FORGOT_PASSWORD_ROUTER,
    Constant.CONFIRM_FORGOT_PASSWORD,
    Constant.APPROVE_SUCCESS_ROUTER,
    Constant.REJECT_SUCCESS_ROUTER,
    Constant.PUBLIC_KNOWLEDGE_LIST_ROUTER,
    Constant.PUBLIC_KNOWLEDGE_DETAIL_ROUTER
];

/**
 * log-out
 * clear data localStorage, sessionStorage
 * clear interval
 *
 * @param {*} history
 */
export const signOut = (history, setUserSession) => {
    console.trace('--------SIGN OUT--------');
    Auth.signOut()
        .then(() => {
            console.log('---- handle signOut')
            unSubscriptionEventDeleteUser();
            let infoCorporation = localStorageUtil.getContractTypeAndSubDomainCorp();
            infoCorporation = Utils.convertJSONDataToObject(infoCorporation);

            let urlAfterLogout = Utils.getUrlLinkCorporation(
                infoCorporation.contractType,
                infoCorporation.subDomainInvite
            );

            localStorageUtil.deleteLisProjectOfUser();
            localStorageUtil.deleteSelectedProjectId();
            localStorageUtil.deleteSelectedProjectType();
            localStorageUtil.deleteUserDetailId();
            localStorageUtil.deleteAffiliationOrganization();
            localStorageUtil.deleteCorporationDomain();
            localStorageUtil.deleteQAanonymousParams();
            localStorageUtil.deleteUserEmail();
            localStorageUtil.deleteSessionBrowserId();

            // clear sessionStorage
            sessionStorageUtil.deleteUserInfoSession();
            sessionStorage.clear();
            if (setUserSession) {
                setUserSession();
            }
            // clear Interval
            clearInterval(window.intervalCheckAuthen);
            // delete cookie
            deleteCookieCdn();

            clearGlobalStateAfterLogout();

            if (
                window.location.pathname !== '/iframe/login' &&
                window.location.pathname !== '/iframe/anonymous/qa'
            ) {
                if (history) {
                    history.push(urlAfterLogout);
                } else {
                    document.location.href = urlAfterLogout;
                }
            }
        })
        .catch(err => console.error(err));
};

const clearGlobalStateAfterLogout = () => {
    setRecoil(notificationListAtom, []);
    setRecoil(notificationUnReadListAtom, []);
    setRecoil(corporationAtom, { ...Constant.CORPORATION_ATOM_DEFAULT_DATA });
    setRecoil(listFormOfCorporationAtom, []);
    setRecoil(fieldListOfCorporationAtom, []);
    setRecoil(multiPanelAtom, []);
    setRecoil(panelStartIndexAtom, 0);
    setRecoil(panelSlideCurrentIndexAtom, 0);
    setRecoil(projectListInCorporationAtom, []);
    setRecoil(helpdeskTicketListDefaultSelectedOptionAtom, []);
    setRecoil(helpdeskTicketListDrillDownDataAtom, []);
    setRecoil(helpdeskTicketListDefaultDrillDownDataAtom, []);
    setRecoil(projectInuseDefaultSelectedOptionAtom, []);
    setRecoil(helpdeskDefaultSelectedOptionAtom, []);
    setRecoil(projectInuseDrillDownDataAtom, []);
    setRecoil(helpdeskDrillDownDataAtom, []);
    setRecoil(projectInuseDefaultDrillDownDataAtom, []);
    setRecoil(helpdeskDefaultDrillDownDataAtom, []);
    setRecoil(userAtom, {});
};

/**
 *
 * @returns
 */
export const getAuthentication = async (history, setUserSession) => {
    const currentUrl = window.location.pathname;

    // Validate not need authen page (public knowledge list,....)
    let notNeedCheckAuthen = true;
    NOT_AUTHEN_ROUTER_LIST.forEach(router => {
        let matchUrl = matchPath(currentUrl, router);
        if (!Utils.isEmptyObject(matchUrl) && matchUrl.isExact) {
            notNeedCheckAuthen = false;
        }
    });

    if (!notNeedCheckAuthen) {
        return;
    }

    let isAutoLogout = false;
    // current screen need auth?
    // console.log('debug_logout ____________________BEGIN____________________');
    const isNotAuthRouterList = NOT_AUTHEN_ROUTER_LIST.includes(currentUrl);
    const isCreateGuestContractUrl = Utils.isCreateGuestContractUrl();
    const isApprovePageUrl = Utils.isApprovePageUrl();
    const isLoginPageUrl = Utils.isLoginPageUrl();
    const isConfirmCreateOrgPageUrl = Utils.isConfirmCreateOrgPageUrl();
    const isConfirmCreateGuestOrgPageUrl = Utils.isConfirmCreateGuestOrgPageUrl();
    if (
        !isNotAuthRouterList &&
        !isCreateGuestContractUrl &&
        !isApprovePageUrl &&
        !isLoginPageUrl &&
        !isConfirmCreateOrgPageUrl &&
        !isConfirmCreateGuestOrgPageUrl
    ) {
        isAutoLogout = true;
    } else {
        // {isNotAuthRouterList, isCreateGuestContractUrl, isApprovePageUrl, isLoginPageUrl, isConfirmCreateOrgPageUrl, isConfirmCreateGuestOrgPageUrl});
        return;
    }

    const userId = localStorageUtil.getUserDetailId();
    const projectId = localStorageUtil.getSelectedProjectId();
    const corporationId = localStorageUtil.getAffiliationOrganization();

    // not login
    if (!userId || !projectId || !corporationId) {
        if (isAutoLogout) {
            console.log('debug_logout ____________________ SIGN OUT 1 ________________');
            signOut(history, setUserSession);
        }
        return;
    }

    // log-out in other tab
    try {
        await Auth.currentAuthenticatedUser();
    } catch (error) {
        console.log('debug_logout >>> currentAuth >>> error: ', error);
        if (isAutoLogout) {
            console.log('debug_logout ____________________ SIGN OUT 2 ________________');
            signOut(history, setUserSession);
        }
        return;
    }

    // check permissions
    let userInforPromiseResponse = await Promise.all([
        getUserById(API, userId),
        getProjectUserInUseDetail(API, userId, projectId),
        getCorporationById(API, corporationId)
    ]).catch(err => {
        console.log('debug_logout ____________________ SIGN OUT 3 ________________');
        signOut(history, setUserSession);
        return;
    });
    const corporationDetail = userInforPromiseResponse[2];

    // user-info in corp
    const userDetail = userInforPromiseResponse[0];
    if (
        Utils.isEmptyObject(userDetail) ||
        userDetail.affiliationOrganization !== corporationId ||
        userDetail?.active === Constant.ACTIVE_FLAG.DELETED ||
        corporationDetail.active === Constant.CORPORATION_ACTIVE.DELETED ||
        corporationDetail.active === Constant.CORPORATION_ACTIVE.BLOCK
    ) {
        console.log('debug_logout ____________________ SIGN OUT 4 ________________');
        signOut(history, setUserSession);
        return;
    }

    // user-info in project
    let isRemovedFromProjectInuse = false;
    const projectUserDetail = userInforPromiseResponse[1];
    if (Utils.isEmptyObject(projectUserDetail)) {
        isRemovedFromProjectInuse = true;
        // return;
    }

    // user login is PM of current project
    let isManager =
        projectUserDetail?.privilege === Constant.PRIVILEGE_PROJECT.PRJ_MGR ? true : false;
    // new UserInfo
    let userInfor = {
        isAuthen: true,
        isProjectManager: isManager,
        isAdmin: Utils.isAdminUser(userDetail),
        type: userDetail.type,
        active: userDetail.active,
        isRemovedFromProjectInuse
    };

    // compare with UserInfoSession in sessionStorage
    let isUserInforChanged = checkUserInfoSessionChange(userInfor);
    if (isUserInforChanged) {
        userInfor.isAuthen = false;
    }

    if (!userInfor.isAuthen) {
        console.log('debug_logout ____________________ SIGN OUT 5 ________________');
        signOut(history, setUserSession);
    }

    return;
};

/**
 *
 * @param {*} userInfor
 * @returns
 */
const checkUserInfoSessionChange = userInfor => {
    let userInfoTemp = sessionStorageUtil.getUserInfoSession();
    let currentProjectList = !Utils.isEmptyArray(userInfoTemp?.projectList)
        ? userInfoTemp?.projectList
        : [];

    if (Utils.isEmptyObject(userInfoTemp)) {
        return true;
    }
    if (
        userInfoTemp.type !== userInfor.type ||
        userInfoTemp.isAdmin !== userInfor.isAdmin ||
        (!userInfor.isRemovedFromProjectInuse &&
            userInfoTemp.isProjectManager !== userInfor.isProjectManager &&
            currentProjectList.includes(userInfoTemp.projectId)) ||
        userInfor.active === Constant.ACTIVE_FLAG.DELETED
    ) {
        console.log('debug_logout --------------- SESSION CHANGE ---------------');
        return true;
    }
    return false;
};

export const getCookieValue = name => {
    // Get all cookie
    let cookies = document.cookie.split('; ');

    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].split('=');
        if (cookie[0] === name) {
            return decodeURIComponent(cookie[1]);
        }
    }

    return null;
};

export const isCookieExpired = cookieName => {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.indexOf(cookieName + '=') === 0) {
            var cookieValue = cookie.substring(cookieName.length + 1);
            var expiresIndex = cookieValue.indexOf('expires=');
            if (expiresIndex !== -1) {
                var expiresDate = new Date(cookieValue.substring(expiresIndex + 8));
                if (expiresDate < new Date()) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
    }
    return false;
};
